import DropdownCard from 'src/Components/MobileComponents/DropdownCard';
import ProfileInfomation from 'src/Components/Profile/ProfileInfomation';

type Props = {
    name?: String;
    email?: String;
    isLoading: Boolean
};

const ProfileCard = (props: Props) => (
    <>
        <div className='invisible mb-4 md:visible mr-6 absolute
                        md:relative w-90 md:w-178 md:h-35 bg-white border-1-5 border-card-normal rounded-md'>
            <ProfileInfomation {...props} isMobile={false} />
        </div>
        <div className='relative md:absolute ml-8 mb-4 flex mr-8 md:invisible visible'>
            <DropdownCard
                heading={
                    'Profile Information'
                }
                body={
                    <ProfileInfomation {...props} isMobile={true} />
                }
            />
        </div>
    </>
);

export default ProfileCard;
